/** Question09 in adobexd */
import React, { useState, useContext, useEffect } from "react";

import {
  Hero,
  Button,
  Back,
  Next,
  LinearGradient,
} from "../../../../components";

import { Container, Section, Buttons, NavigateButtons } from "./styles";
import { DataUserContext, NavigateButtonsContext } from "../..";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendTimeExpectation } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question08: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);

  const [selectIcon, setSelectIcon] = useState<string>("");

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  const [error, setError] = useState<number>(0);

  useEffect(() => {
    const isValid = selectIcon !== "";

    if (isValid) {
      setRequirementsFulfilled(true);
    }
  }, [selectIcon]);

  function submit() {
    if (requirementsFulfilled) {
      sendTimeExpectation(
        {
          expectativa_de_tempo: selectIcon,
        },
        token
      );

      next(10);
    } else setError((prevState) => prevState + 1);
  }

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 9);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_expectativa_de_tempo.propriedades.imagens.etapa_expectativa_de_tempo_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_expectativa_de_tempo.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_expectativa_de_tempo.propriedades.conteudo.titulo"
              )}
            </p>

            <p>
              {can(
                theme,
                "theme.steps.etapa_expectativa_de_tempo.propriedades.conteudo.subtitulo"
              )}
            </p>

            <Buttons>
              {can(
                theme,
                "theme.steps.etapa_expectativa_de_tempo.propriedades.conteudo.inputs"
              ) &&
                theme.steps.etapa_expectativa_de_tempo.propriedades.conteudo.inputs.map(
                  ({ valor, icone, id, texto }, index) => (
                    <Button
                      criare
                      key={id}
                      disableOnFocus={selectIcon !== valor}
                      selected={selectIcon === valor}
                      onClick={() => setSelectIcon(valor)}
                      icon={
                        <img
                          src={can(
                            theme,
                            `theme.steps.etapa_expectativa_de_tempo.propriedades.conteudo.inputs[${index}].icone[1]`
                          )}
                          alt=""
                        />
                      }
                      title={texto}
                      small
                    />
                  )
                )}
            </Buttons>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question08;
